import Component from './beneficial-owner-form';
export default Component;
